import * as React from 'react';
import { connect } from 'react-redux';
import './ClaimInfo.css';
import { showCallMeModal, showFnolCallMeModal } from '../../../actions/modalActions';
import ClaimOverview from './ClaimHistorySteps/ClaimOverview';
import NotificationOfClaim from './ClaimHistorySteps/NotificationOfClaim';
import ClaimRegistration from './ClaimHistorySteps/ClaimRegistration';
import ClaimCarHire from './ClaimHistorySteps/ClaimCarHire';
import Towing from './ClaimHistorySteps/Towing';
import Assesment from './ClaimHistorySteps/Assesment';
import ClaimProcessing from './ClaimHistorySteps/ClaimProcessing';
import Repairs from './ClaimHistorySteps/Repairs';
import ClaimCompleted from './ClaimHistorySteps/ClaimCompleted';
import LoadingOrEmpty from './ClaimHistorySteps/LoadingOrEmpty';
import { getOverview, setLoadingAndEmpty } from '../../../actions/claimHistoryActionsV2';
import { Accordion, Card } from 'react-bootstrap';
import FAQItem from '../../FAQ/FAQItem';
import NeedHelp from '../../../../src/components/BaseTemplate/SSPCustomComponentLibrary/NeedHelp/NeedHelp';

class ClaimInfo extends React.PureComponent<any, any> {

    constructor(props: any) {
        super(props);
        this.state = {
            accordionFAQActiveKey: -1,
        };
        this.handleCallMeBack = this.handleCallMeBack.bind(this);
        this.handleGetOverview = this.handleGetOverview.bind(this);
        this.handleAccordianArrow = this.handleAccordianArrow.bind(this);
    }

    handleAccordianArrow(e: any) {
        this.setState({ accordionFAQActiveKey: e })
    }

    handleCallMeBack(e: any) {
        this.props.handleCallMeBack();
    }

    handleGetOverview(e: any) {
        this.props.dispatchGetOverview();
    }

    getClaimStatusClass() {
        let cssClass = '';
        switch (this.props.claimSubmit.selectedClaim.claimStatusCategory) {
            case 'Approved': cssClass = 'Approved'; break;
            case 'Pending': cssClass = 'Pending'; break;
            case 'Cancelled': cssClass = 'Cancelled'; break;
            default: cssClass = 'hidden';
        }
        return cssClass;
    }

    public render() {
        let faq = '';
        if (this.props.claimSubmit.claimsFAQs) {
            faq = this.props.claimSubmit.claimsFAQs.map((item) => {
                if (item.questionText !== "") {
                    return <FAQItem header={item.questionText} body={item.questionAnswer} keyId={item.processQuestionNumber} activeKey={this.state.accordionFAQActiveKey} />
                }
            });
        }
        return (
            <>
                <div id="ClaimInfoCard">
                    {!this.props.claimsHistory.isLoading && !this.props.claimsHistory.isEmpty &&
                        <>
                            {this.props.profile.selectedPersonalClaimStep && this.props.claimSubmit.selectedClaimProgressStep?.claimStepDescription.toLowerCase() === "overview" &&
                                <ClaimOverview />
                            }
                            {this.props.profile.selectedPersonalClaimStep && this.props.claimSubmit.selectedClaimProgressStep?.claimStepDescription.toLowerCase() === "notification of claim" &&
                                <NotificationOfClaim />
                            }
                            {this.props.profile.selectedPersonalClaimStep && this.props.claimSubmit.selectedClaimProgressStep?.claimStepDescription.toLowerCase() === "claim registration" &&
                                <ClaimRegistration />
                            }
                            {this.props.profile.selectedPersonalClaimStep && this.props.claimSubmit.selectedClaimProgressStep?.claimStepDescription.toLowerCase() === "car hire" &&
                                <ClaimCarHire />
                            }
                            {this.props.profile.selectedPersonalClaimStep && this.props.claimSubmit.selectedClaimProgressStep?.claimStepDescription.toLowerCase() === "towing" &&
                                <Towing />
                            }
                            {this.props.profile.selectedPersonalClaimStep && this.props.claimSubmit.selectedClaimProgressStep?.claimStepDescription.toLowerCase() === "assessment" &&
                                <Assesment />
                            }
                            {this.props.profile.selectedPersonalClaimStep && this.props.claimSubmit.selectedClaimProgressStep?.claimStepDescription.toLowerCase() === "claim processing" &&
                                <ClaimProcessing />
                            }
                            {this.props.profile.selectedPersonalClaimStep && this.props.claimSubmit.selectedClaimProgressStep?.claimStepDescription.toLowerCase() === "repairs" &&
                                <Repairs />
                            }
                            {this.props.profile.selectedPersonalClaimStep && this.props.claimSubmit.selectedClaimProgressStep?.claimStepDescription.toLowerCase() === "claim completed" &&
                                <ClaimCompleted />
                            }
                        {this.props.claimSubmit.claimsFAQs && this.props.claimSubmit.claimsFAQs.length > 0 && (this.props.claimSubmit.selectedClaimProgressStep?.claimStepDescription.toLowerCase() !== "overview" && this.props.claimSubmit.selectedClaimProgressStep?.claimStepDescription.toLowerCase() !== "claim completed" && this.props.claimSubmit.selectedClaimProgressStep?.claimStepDescription.toLowerCase() !== "car hire") && !this.props.claimsHistory.isLoading && !this.props.claimsHistory.isEmpty && this.props.claimSubmit.claimsFAQs[0].questionText !== "" && (!this.props.claimSubmit.selectedClaimProgressStep?.isComplete || (this.props.claimSubmit.selectedClaimProgressStep?.isComplete && this.props.claimSubmit.selectedClaimProgressStep?.claimStepDescription.toLowerCase() === "assessment" && this.props.claimSubmit.selectedClaimProgressStep?.claimType === "Motor Vehicle W/O")) &&
                                <div id="claimFAQ" className="content-box-padding-20px-with-box-shadow mt-10px card">
                                    <p className="claim-step-subtitle">FAQs</p>
                                    <Card className="policyDetailsCodeRed ">
                                        <div className="pr-2 new-ssp-code-red-faq-block code-red-accordion-holder">
                                            <Accordion onSelect={(e) => this.handleAccordianArrow(Number(e))}>
                                                {faq}
                                            </Accordion>
                                        </div>
                                    </Card>
                                </div >
                            }
                            {this.props.profile.selectedPersonalClaimStep && this.props.claimSubmit.selectedClaimProgressStep?.claimStepDescription.toLowerCase() !== "overview" && !this.props.claimSubmit.selectedClaimProgressStep?.isComplete &&
                                <div id="needHelp" className="mt-10px">
                            <NeedHelp
                                isClaims={true}
                                countryId={this.props.profile.countryId}
                                claimsEmail={this.props.ssp.claims_email}
                                contactUsTel={this.props.ssp.contactUs_tel}
                                handleCallMeBack={(e) => this.handleCallMeBack(e)}
                                />
                            </div >
                            }
                        </>
                    }
                    {(this.props.claimsHistory.isLoading || this.props.claimsHistory.isEmpty) &&
                        <LoadingOrEmpty />
                    }
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        auth: state.firebase.auth,
        firebase: state.firebase,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
        claimsHistory: state.claimsHistory,
        ssp: state.ssp
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleCallMeBack: () => dispatch(showFnolCallMeModal()),
        dispatchHandleSetLoadingAndEmpty: (loading, empty) => dispatch(setLoadingAndEmpty(loading, empty)),
        dispatchGetOverview: () => dispatch(getOverview())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClaimInfo);